object AppBuildConfig {
    const val DEBUG = true
    private const val VERSION = 96
    private const val VERSION_BACKEND = 79
    private const val VERSION_REPORTS = 27
    const val HOST_BACKEND = "https://my.test.screensoft.org"
    const val HOST_REPORTS = "https://report.test.screensoft.org"
    const val HOST_FILES = "https://files.test.screensoft.org"
    const val HOST_BALANCER = "message.test.screensoft.org"
    const val PORT_BALANCER = 443
    const val HOST_ICONS = "icons.test.screensoft.org"
    const val PORT_ICONS = 443
    const val URL_ICONS = "https://icons.test.screensoft.org"

    override fun toString(): String {
        return buildString {
            appendLine("version:$VERSION")
            appendLine("version_backend:$VERSION_BACKEND")
            appendLine("version_reports:$VERSION_REPORTS")
        }
    }
}